import { components } from "./components/index";
import { events } from "./events/index";

const TeamsSection = {
  components,
  events
};

export { TeamsSection };